import { RelexLogo } from "@relex-solutions/fragments"
import { useTranslation } from "react-i18next"
import styles from "./CmtLogo.module.css"

export function CmtLogo() {
  const { t } = useTranslation()
  return (
    <div className={styles.container}>
      <RelexLogo hasName />
      <p className={`${styles.toolName} fr-text-400-strong`} data-testid="cmt-logo-title">
        {t("header.title")}
      </p>
    </div>
  )
}
